import {REMOVE_AUTH, SET_AUTH, SET_WARE_CODE} from "./types";
const actions = {
    setAuth: ({commit}, authInfo) => {
        commit(SET_AUTH, authInfo)
    },
    setWareCode: ({commit}, wareCode) => {
        commit(SET_WARE_CODE, wareCode)
    },
    removeAuth: ({commit}) => {
        commit(REMOVE_AUTH)
    },

}
export default actions